<template>
  <v-dialog v-model="showModal" persistent>
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos processando os dados...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="checkin-text"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>

    <!-- <v-card class="pa-3" v-if="complete">
      <span class="title total">Complete seus dados:</span>
      <v-divider></v-divider>
      <v-btn icon class="float" v-if="showClose" @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-flex xs12>
        <v-text-field
          v-model="user.cpf"
          color="grey darken-2"
          v-mask="'###.###.###-##'"
          label="CPF"
        ></v-text-field>
        <v-text-field
          v-model="user.drive_license"
          color="grey darken-2"
          v-mask="'###########'"
          label="CNH"
        ></v-text-field>
        <v-text-field
          v-model="user.phone"
          color="grey darken-2"
          v-mask="'(##)#########'"
          label="Telefone"
        ></v-text-field>
        <v-text-field
          v-model="user.birthday"
          color="grey darken-2"
          v-mask="'##/##/####'"
          label="Data de Nascimento"
        ></v-text-field>
      </v-flex>
      <v-btn large class="btnColor ma-0 w-100 mt-3" @click="updatePartial()">
        <span class="white--text font-weight-bold">Atualizar dados</span>
      </v-btn>
    </v-card> -->

    <v-card class="pa-3">
      <span class="title total">Novo cartão:</span>
      <v-divider></v-divider>
      <v-btn icon class="float" v-if="showClose" @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-flex xs12>
        <v-text-field
          color="grey darken-2"
          v-mask="'################'"
          label="Número do cartão"
          v-model="creditCardNumber"
          required
        ></v-text-field>
        <v-text-field
          color="grey darken-2"
          type="text"
          label="Nome (Como escrito no cartão)"
          v-model="creditCard.name"
          required
        ></v-text-field>
        <v-text-field
          color="grey darken-2"
          v-mask="'##'"
          label="Validade (Mes)"
          v-model="creditCard.month"
          required
        ></v-text-field>
        <v-text-field
          color="grey darken-2"
          v-mask="'##'"
          label="Validade (Ano)"
          v-model="creditCard.year"
          required
        ></v-text-field>
        <v-text-field
          color="grey darken-2"
          v-mask="'####'"
          label="CVV"
          v-model="creditCard.cvv"
          required
        ></v-text-field>
        <v-select
          color="grey darken-2"
          :items="options"
          v-model="creditCard.flag"
          label="Selecione a bandeira do cartão"
          required
        ></v-select>
        <v-btn @click="addCard()" class="btnColor ma-0 w-100 mt-3">
          <span class="white--text font-weight-bold">Adicionar Cartão</span>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
import UserController from "./../../controllers/UserController.js";
import User from "./../../models/User.js";
import MaskHelper from "../../helpers/MaskHelper";
import dateHelper from "../../helpers/DateHelper";
import CreditCardController from "./../../controllers/UserCreditCardController.js";
import CreditCard from "./../../models/UserCreditCard.js";
import AddressController from "./../../controllers/AddressController.js";
import Address from "./../../models/Address.js";
import axios from "axios";
import PaymentController from "./../../controllers/PaymentController";

export default {
  props: {
    showModal: { type: Boolean, default: false },
    showClose: { type: Boolean, default: true }
  },

  async created() {
    await this.getUser();
  },

  data() {
    return {
      options: [
        { text: "Visa", value: "VISA" },
        { text: "Mastercard", value: "MASTERCARD" },
        { text: "American Express", value: "AMEX" },
        { text: "Elo", value: "ELO" },
        { text: "Aura", value: "AURA" },
        { text: "JCB", value: "JCB" },
        { text: "Diners", value: "DINERS" },
        { text: "Discover", value: "DISCOVER" },
        { text: "Hipercard", value: "HIPERCARD" },
        { text: "Hiper", value: "HIPER" }
      ],
      cardFlag: null,
      sameAdress: false,
      complete: false,
      userController: new UserController(this.$resource),
      user: new User(),
      creditCardController: new CreditCardController(this.$resource),
      creditCard: new CreditCard(),
      address: new Address(),
      addressController: new AddressController(this.$resource),
      paymentController: new PaymentController(this.$resource),
      id_address: null,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      blockScreen: false,
      creditCardNumber: ""
    };
  },
  watch: {
    creditCardNumber(val) {
      if (val.length >= 6) {
        this.paymentController.getCardBin(val).then(res => {
          if(res.Status && res.Status=="00"){
            this.creditCard.flag = res.Provider
          }
        });
      }
    }
  },
  methods: {
    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    async getUser() {
      await this.userController
        .getUserData()
        .then(res => {
          this.user = res.user;
          this.id_address = this.user.id_address;
          this.ifComplete();
        })
        .catch(error => {
          this.alert("Erro ao buscar dados do usuário.", "error");
        });
    },

    updatePartial() {
      this.user.birthday = dateHelper.stringBarrastoDate(this.user.birthday);
      this.userController
        .partialUpdate(this.user)
        .then(() => {
          this.ifComplete();
        })
        .catch(error => this.alert("Erro ao atualizar dados.", "error"));
    },

    addAdrress() {
      this.addressController
        .create(this.address)
        .then(res => {
          this.id_address = res.id_address;
          this.saveCard();
        })
        .catch(error => this.alert("Erro ao salvar endereço.", error));
    },

    async saveCard() {
      this.creditCard.number = this.creditCardNumber;
      let number = this.creditCardNumber.substr(-4);
      this.creditCard.id_address = this.id_address;
      this.creditCard.id_user = this.user.id;
      this.creditCard.id_pagarme = 1;
      this.creditCard.nickname = this.creditCard.flag + " - " + number;

      this.creditCard.name = this.creditCard.name.toUpperCase();
      let res = this.creditCard.name.match("[^A-Z- ]");

      if (res) {
        this.$emit("alert", {
          text: "Falha ao cadastrar cartão, Nome inválido.",
          color: "error"
        });
        return;
      }

      await this.creditCardController.create(this.creditCard).then(
        res => {
          if (res.ok) {
            this.$emit("alert", {
              text: res.message.message,
              color: "success"
            });
            this.clear();
          } else {
            this.$emit("alert", {
              text:
                "Falha ao cadastrar cartão, verifique os dados e tente novamente.",
              color: "error"
            });
          }
        },
        err => {
          throw "Falha ao cadastrar cartão, verifique os dados e tente novamente.";
        }
      );
    },

    clear() {
      this.showModal = false;
      this.showClose = true;
      this.creditCard = new CreditCard();
      this.creditCardNumber = "";
      this.address = new Address();
      this.$emit("close");
    },

    async addCard() {
      try {
        this.blockScreen = true;
        this.saveCard();
      } catch (error) {
        this.alert(error, "error");
      } finally {
        this.blockScreen = false;
      }
    },

    ifComplete() {
      if (
        this.user.cpf === null ||
        this.user.drive_license == "" ||
        this.user.phone === null ||
        !this.user.birthday
      )
        this.complete = true;
      else this.complete = false;
    },
    
    validaCep() {
      axios
        .get(`https://viacep.com.br/ws/${this.address.zip}/json/`)
        .then(response => {
          this.address.state = response.data.uf;
          this.address.street = response.data.logradouro;
          this.address.city = response.data.localidade;
          this.address.neighborhood = response.data.bairro;
        })
        .catch(error => {
          this.alert("CEP inválido.", "error");
        });
    }
  },

  computed: {
    validaAddress() {
      if (this.sameAdress) {
        this.creditCard.sameAddress = true;
        return !this.sameAdress;
      }
      return this.addressController.validaAddres(this.address);
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  height: 100vh;
}

.sizeTop {
  height: 48px;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.bottom {
  margin-bottom: 60px;
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.colorSelected {
  color: var(--secondary-color) !important;
}

.btnColor {
  background-color: var(--primary-color) !important;
}

.icon-size {
  font-size: 60px;
}

.total {
  color: #181f4d;
}

.float {
  position: absolute;
  color: var(--secondary-color);
  top: 0;
  right: 0;
}
</style>
